export default "__VITE_ASSET__97c51b1b__"